































import { Component, Mixins, Ref, Vue } from "vue-property-decorator";
import { Action, State } from "vuex-class";

import AppContent from "@/components/AppContent/AppContent.vue";
import AppHeader from "@/components/AppHeader/AppHeader.vue";
import AppHeaderMain from "@/components/AppHeader/AppHeaderMain.vue";
import TeacherForm from "@/components/TeacherForm/TeacherForm.vue";

import BaseSpinner from "@/components/BaseSpinner/BaseSpinner.vue";
import BaseAlert from "@/components/BaseAlert/BaseAlert.vue";
import BasePopup from "@/components/BasePopup/BasePopup.vue";
import BaseButton from "@/components/BaseButton/BaseButton.vue";

import RequestState from "@/utils/mixins/RequestState";

import { ITeacherPayload } from "@/models/interfaces/teachers";
import { AxiosError } from "axios";
import amplitude from "amplitude-js";
import { eventCodeByName, EventsNames } from "@/analytics";

interface TeacherFormType {
  setLoadingState: (state: boolean) => void;
}

@Component({
  components: {
    AppContent,
    AppHeader,
    AppHeaderMain,
    TeacherForm,

    BaseSpinner,
    BaseAlert,
    BasePopup,
    BaseButton
  }
})
export default class TeachersAdd extends Mixins(RequestState) {
  @Ref("form")
  private form!: HTMLFormElement & TeacherFormType;

  @Action("teachers/createTeacher")
  private createTeacher!: (
    payload: ITeacherPayload
  ) => Promise<{ userId: string } | AxiosError>;

  private showValidationPopup = false;
  private popupTimeout!: number;

  private popupMessage = "";
  private creationMessage = this.$t("views.teachers.messages.create") as string;

  private showPopup(message: string) {
    this.popupMessage = message;
    this.showValidationPopup = true;
  }

  private addTeacher(form: ITeacherPayload) {
    amplitude
      .getInstance()
      .logEvent(
        `${eventCodeByName(EventsNames.UserClicksSaveOnCreateTeacherPage)} ${
          EventsNames.UserClicksSaveOnCreateTeacherPage
        }`
      );

    this.form.setLoadingState(true);

    this.createTeacher(form)
      .then(() => {
        this.popupMessage = this.creationMessage;
        this.showValidationPopup = true;
      })
      .finally(() => {
        this.form.setLoadingState(false);
      });
  }

  private onPopupClose() {
    this.showValidationPopup = false;

    if (this.popupMessage === this.creationMessage) {
      amplitude
        .getInstance()
        .logEvent(
          `${eventCodeByName(
            EventsNames.UserClicksOkOnPopupAfterTeacherCreate
          )} ${EventsNames.UserClicksOkOnPopupAfterTeacherCreate}`
        );

      this.popupTimeout = window.setTimeout(() => {
        this.$router.push("/teachers");
      }, 500);
    }
  }

  public beforeDestroy() {
    window.clearTimeout(this.popupTimeout);
  }
}
